'use client'

import { useState, useEffect } from 'react'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger
} from '@/components/ui/dialog'
import { AuthForm } from './auth-form'
import { useAuth } from '@/hooks/useAuth'

interface LoginDialogProps {
  children: React.ReactNode
  open?: boolean
  onOpenChange?: (open: boolean) => void
}

export function LoginDialog({
  children,
  open: controlledOpen,
  onOpenChange: controlledOnOpenChange
}: LoginDialogProps) {
  const { user } = useAuth()
  const [internalOpen, setInternalOpen] = useState(false)

  const isControlled = controlledOpen !== undefined
  const open = isControlled ? controlledOpen : internalOpen
  const setOpen = isControlled ? controlledOnOpenChange : setInternalOpen

  // Close dialog when user successfully logs in
  useEffect(() => {
    if (user && open) {
      setOpen?.(false)
    }
  }, [user, open, setOpen])

  const handleSuccess = () => {
    // Dialog will close automatically when user state updates
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Sign in</DialogTitle>
          <DialogDescription>
            Sign in to sync your flashcards, saved words, and reading
            preferences across all your devices.
          </DialogDescription>
        </DialogHeader>
        <AuthForm onSuccess={handleSuccess} compact />
      </DialogContent>
    </Dialog>
  )
}
